
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SizeAndPrice, VirtualMachine, VmImage } from '@/models/VirtualMachine';
import { Helper, WorkspaceDetailsParams } from '@/models/HelperClasses';
import SizeAndPriceTable from '../shared/SizeAndPriceTable.vue';
import { ajaxGet, ajaxPost } from '@/data/ajax';
import { mapState } from 'vuex';
import { ComponentParameter_Post } from "@/models/CreateWorkspace";
import { Budget } from "@/models/Budget";

@Component({
    components: {SizeAndPriceTable},
    computed: {
    ...mapState(["sizeAndPrices", "vmImages", "sizeAndPrices"])
    }
})
export default class AddVirtualMachine extends Vue {
    @Prop() private currentWorkspaceCostPerDay: number;
    @Prop() private budget: Budget;

    public vmImages!: VmImage[]; //Is assigned via mapstate
    public sizeAndPrices!: SizeAndPrice[]; //Is assigned via mapstate
    private showVmSize: boolean = false;
    private selectedImageId: string = null;
    private selectedSize: SizeAndPrice = null;
    private addingVM: boolean = false;
    private template: string = "";
    private futureDaysOfBudgetRemaining: number;

    formatMoney(money: number){
        return Helper.formatMoney(money);
    }

    setDefaultSize(imageId: string, parameterName: string){
        var selectedImage = this.vmImages.find(image =>{
            return image.id === imageId;
        });
        this.selectedSize = this.sizeAndPrices.find(sizeAndPrice => {
            return sizeAndPrice.technicalName === selectedImage.defaultSizeTechnicalName;
        });
        if(!this.selectedSize){
            console.error("Could not find size" + selectedImage.defaultSizeTechnicalName);
        }
        this.template = selectedImage.componentFile;
        var futureWorkspaceCostPerDay = this.currentWorkspaceCostPerDay + this.selectedSize.pricePerHour*24 + 0.6;
        var budgetleft = this.budget.amount * 0.95 - this.budget.currentSpend;
        var daysRemaining = budgetleft /futureWorkspaceCostPerDay;
        daysRemaining = daysRemaining < 0 ? 0 : daysRemaining;
        this.sizeSelected(this.selectedSize, daysRemaining);
    }

    sizeSelected(sizeAndPrice: SizeAndPrice, futureDaysOfBudgetRemaining: number){
        this.selectedSize = sizeAndPrice;
        this.futureDaysOfBudgetRemaining = futureDaysOfBudgetRemaining;
        this.showVmSize = false;
    }

    async addVirtualMachine(){
        var continueAdding = await this.checkFutureDaysRemaining();
        if(!continueAdding) return;
        this.addingVM = true;
        this.$emit("addVMStarted");
        const url =
        process.env.VUE_APP_ROOT_API +
        `Workspace/${this.$route.params.resourceGroupName}/subscription/${this.$route.params.subscriptionId}/AddComponentToWorkspace/${this.template}`;
        var token = await this.$store.state.authModule.getapiTokenPopup();
        var parameters = {
            imageReference: this.selectedImageId,
            vmSize: this.selectedSize.technicalName,
            imageDisplayName: this.vmImages.find(x => x.id === this.selectedImageId).displayName
        }
        var result = await ajaxPost(url, token, parameters);
        var workspaceDetailsParams = new WorkspaceDetailsParams(this.$route.params);

        // re-enable if auto-refresh is ever turned off
        //await this.$store.dispatch("getWorkspaceDetails", workspaceDetailsParams);

        this.addingVM = false;
        this.$emit("addVMComplete");

        this.$swal({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000000,
            type: "success",
            text: "A new virtual machine is now deploying, it should be available in a few minutes. Please refresh the page to see the changes.",
            showCloseButton: true
        });
    }

    async checkFutureDaysRemaining(): Promise<boolean> {
        if(this.futureDaysOfBudgetRemaining > 5){
            return true;
        } else if (this.futureDaysOfBudgetRemaining > 1){
            var answer = await this.$swal({
                title:
                    `Are you sure you want to add this VM or scale to this size? With this vm/size the budget will be spent in ${Math.floor(this.futureDaysOfBudgetRemaining)} days`,
                showCancelButton: true,
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                allowOutsideClick: true
            });
            if(answer.value){
                return true
            } 
            return false;
        }
        var answer = await this.$swal({
            title:
                `Your budget is insufficient to add this VM or scale to this size because the budget will be spent in less than 1 day.`,
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: "Ok",
            allowOutsideClick: true
        });
        return false;
    }

    created(){
        this.$store.dispatch("getVmImages");
        this.$store.dispatch("getSizeAndPrices");
    }
}
